import { mapSuggestion } from '@frontend/react-domain';
import { useDismissedSuggestionsSlice } from '@frontend/redux';
import { XStack } from '@frontend/web-react';
import { useAnalytics, useListSuggestionsQuery } from '@frontend/web/hooks';
import { useMemo } from 'react';
import { SuggestionChip } from './SuggestionChip';

type SuggestionListProps = {
  onSuggestionSelect: (description: string) => void;
};

export const SuggestionList = ({ onSuggestionSelect }: SuggestionListProps) => {
  const { track } = useAnalytics();
  const { dismissedSuggestions } = useDismissedSuggestionsSlice();
  const { data: suggestionsData } = useListSuggestionsQuery();

  const suggestions = useMemo(
    () =>
      (suggestionsData ?? [])
        .map(mapSuggestion)
        .filter((s) => !dismissedSuggestions.includes(s.suggestionId))
        .slice(0, 3),
    [suggestionsData, dismissedSuggestions],
  );

  if (!suggestions.length) {
    return null;
  }

  return (
    <XStack
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
      className="overflow-x-auto gap-[6px] pr-lg"
      flexWrap="nowrap"
      pt="md"
    >
      {suggestions.map((suggestion) => (
        <SuggestionChip
          key={suggestion.suggestionId}
          onPress={() => {
            track({
              data: { suggestion: suggestion.draftDescription, suggestionId: suggestion.suggestionId },
              event: 'suggestionSelected',
              topic: 'suggestions',
            });
            onSuggestionSelect(suggestion.draftDescription);
          }}
          suggestion={suggestion}
        />
      ))}
    </XStack>
  );
};
